module.exports = __webpack_public_path__ + "img/stock6.fa8116c8.png";